// src/services/nutritional-deficit.service.js//
import ApiService from "./api.service";
// import ApiMockService from './api.mock.service'

/**
 * * Digestive Disorders
 *
 * getDigestiveDisorders --> Get List Digestive Disorders
 *
 */
const DigestiveDisordersService = {
  getDigestiveDisorders: async function (params = {}, lang) {
    const response = await ApiService._get("api/digestive-disorder", params, lang);
    return response.data;
  },
};
export default DigestiveDisordersService;
